<button mat-icon-button color="primary" class="load-photos" (click)="loadPhotos()" *ngIf="!loaded && !loading">
  <mat-icon>cached</mat-icon>
</button>
<mat-spinner [diameter]="20" *ngIf="!loaded && loading"></mat-spinner>
<div [class]="{'hidden': !loaded}">
  <div>{{nbrOfPhotos}} photos ({{creche.photos.length}} refs)</div>
  <div>{{storageSize | storage: '1.2-2'}}</div>
</div>
